import { 
    FormControlLabel,
    Grid,
    Switch
} from "@material-ui/core";
import React, { useState } from "react";


const Acceso = ({Titulo, Modulo, isActive = false, handleUpdateAcceso, idUser, Seccion, enqueueSnackbar})=>{

    const [ getActive, setActive ] = useState(isActive);

    const handleChange = ({target})=>{
        setActive(target.checked);        
        fetch('/api/users/Accesos',{
            method:'PUT',
            body: JSON.stringify({Modulo, Titulo, isActive:target.checked, Seccion, idUser }),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result._id){
                handleUpdateAcceso( result );
                enqueueSnackbar('Acceso Actualizado', {variant:'success'});     
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
            }
        });
    };

    return (
        <Grid item xs={6}>
          <FormControlLabel
                control={<Switch checked={getActive} onChange={handleChange} name={Modulo} />}
                label={Titulo}
            />
        </Grid>
    );
};



export default Acceso;